<template lang="html">

  <div class="wrapper -internacional">

    <div class="encabezado">

      <div class="container column-start">
        <div class="contenedor-logo">
          <router-link to="/">
            <img src="/static/img/UFV-logo.png" alt="Logo UFV">
          </router-link>
        </div>
        <h1>Guía</h1>

      </div>

    </div>

    <div class="migas">
      <div class="container">
        <nav class="row-start">
          <router-link to="/">Home</router-link>
          <router-link :to="$t('enlaces.alumnos')">Alumnos y alumni</router-link>
          <router-link :to="$t('enlaces.internacional')">Internacional</router-link>
          <router-link class="row-center" :to="$t('enlaces.guia')">Guía</router-link>

        </nav>
      </div>
    </div>

      <div class="container column-center empresas">
        <div class="texto">
          <h2 class="big-bold-title guia">¿Te gustaría saber más detalles sobre las opciones de prácticas o empleo internacional?
            <br>
            ¿Necesitas más información sobre la formalización de tus prácticas internacionales?
          </h2>
          <h2 class="big-bold-title empresas guia azul">Guía de prácticas internacionales</h2>
          <p class="guia">¿Quieres hacer prácticas internacionales? <span>Te presentamos varias opciones para poder hacerlas</span></p>
        </div>
      </div>

    <div class="container column-center empresas guia">
        <div class="num">
          <div class="titulo guia">
            <div>
              <h1 class="big-bold-title -blue -guia uno">1</h1>
            </div>
            <div class="eventos-barometro -guia">
              <h3 class="subtitle -observatorio -guia">Intercambio académico de estudios:
                <br> Matriculándote en la asigantura de prácticas en la universidad de destino
              </h3>
            </div>
          </div>

        <div class="container empresas -guia">
          <div class="texto">

            <p class="guia">Si la asigantura está alojada en un curso superior, tienes que dirigir una instancia (solicitud genérica) a la Dirección de Ordenación
              Académica para que te puedan autorizar la matrícula anticipada de la misma. <span>Siempre y cuando tu planesde estudios esté implantado</span>
               hasta el curso académico en el que se aloja la asignatura de prácticas.
               <br><br>
               El tutor internacional será quien te aconseje y verifique la circunstancia con Ordenación Académica.<br><br>
               Las prácticas serán evaluadas en la Universidad de destino y posteriormente la calificación se realizará mediante
               transferencia de créditos.<br><br>
               </p>
               <p class="span-guia">La formalización de las prácticas en esta opción será mediante la <strong>transferencia de créditos.</strong></p>

          </div>
          <div class="imagen-guia">
            <img src="/static/img/acceso-practica-proyecto.jpg">
          </div>

        </div>


        </div>
    </div>




    <div class="container column-center empresas guia">
        <div class="num">
          <div class="titulo guia">
            <div>
              <h1 class="big-bold-title -blue -guia">2</h1>
            </div>
            <div class="eventos-barometro -guia">
              <h3 class="subtitle -observatorio -guia dos">Aprovechando tu estancia en el extranjero por intercambio de estudios
              </h3>
            </div>
          </div>

        <div class="container empresas -guia">
          <div class="texto">

            <p class="guia">Durante tu estancia de estudios internacional, puedes realizar prácticas curriculares en
              cualquier empresa, mediante la formalización de la documentación correspondiente entre la UFV y la empresa, 
              siempre que se den los requisitos necesarios marcados en el <span>Reglamento de Prácticas</span>
               <br><br>
               <span>Estas prácticas pueden ser tanto extracurriculares como curriculares</span><br><br>
               Evaluación y seguimiento se dará por parte de tu tutor de prácticas UFV.
               </p><br>
               <p class="span-guia">La formalización de las prácticas en esta opción será: </p>
                 <ul class="listado-guia">
                   <li>En <span>Europa</span> mediante el <span>Programa Erasmus+Prácticas</span> (Oficina de Relaciones Internacionales -ORI- Y Departamento de Prácticas y Empleo)
                   </li>
                   <li><span>Fuera de Europa</span> mediante <span>convenio y anexo de prácticas</span> (Departamento de Prácticas y Empleo)</li>
                 </ul>
          </div>
          <div class="imagen-guia">
            <img src="/static/img/acceso-practica-proyecto.jpg">
          </div>
        </div>
        </div>
    </div>
  
    


      <div class="container column-center empresas guia">
        <div class="num">
          <div class="titulo guia">
            <div>
              <h1 class="big-bold-title -blue -guia uno">3</h1>
            </div>
            <div class="eventos-barometro -guia">
              <h3 class="subtitle -observatorio -guia">Sin necesidad de que realices un intercambio académico de estudios, <br> si tienes posibilidad de viajar al extranjero
              </h3>
            </div>
          </div>

        <div class="container empresas -guia">
          <div class="texto">

            <p class="guia">Tienes la posibilidad de realizar prácticas curriculares en cualquier empresa, 
              mediante la formalización de la documentación correspondientes entre la UFV y la empresa, siempre que se den los requisitos
               necesarios marcados en el <span>Reglamento de Prácticas</span>
               <br><br>
               Estas prácticas pueden ser tanto extracurriculares como curriculares.<br><br>
               Evaluación y seguimiento se dará por parte de tu tutor de prácticas UFV.
               </p><br>
               <p class="span-guia">La formalización de las prácticas en esta opción será: </p>
                 <ul class="listado-guia">
                   <li>En <span>Europa</span> mediante el <span>Programa Erasmus+Prácticas</span> (Oficina de Relaciones Internacionales -ORI- Y Departamento de Prácticas y Empleo)
                   </li>
                   <li><span>Fuera de Europa</span> mediante <span>convenio y anexo de prácticas</span> (Departamento de Prácticas y Empleo)</li>
                 </ul>
            </div>
            <div class="imagen-guia">
            <img src="/static/img/acceso-practica-proyecto.jpg">
          </div>
          </div>
        </div>
    </div>



      <section class="quienes-somos-home row-center guia">

      <div class="contenedor-personas container row-center ais">


        <article class="persona" data="ana-corral">
          <div class="contenedor-datos column-center">
            <h2>Ana de Corral Zunzunegui</h2>
            <p>Coordinadora de Prácticas y Empleo
              Facultad de Derecho, Empresa y Gobierno</p>
            <a href="mailto:a.corral@ufv.es">a.corral@ufv.es</a>
          </div>
        </article>

        <article class="persona" data="beatriz-prada">
          <div class="contenedor-datos column-center">
            <h2>Beatriz de Prada Rodríguez</h2>
            <p>Técnico de Prácticas y Empleo Facultad de Derecho, Empresa y Gobierno</p>
            <a href="mailto:beatriz.deprada@ufv.es">beatriz.deprada@ufv.es</a>
          </div>
        </article>


      </div>

      <div class="texto">
        <p class="texto-quienes-somos">Ana de Corral y Beatriz de Prada son las responsables que te ayudarán y guiarán en tu proceso internacional.
          Ponte en contacto con ellas para concretar una entrevista personalizada.
        </p>
        <div class="contenedor-boton">
      <router-link :to="$t('enlaces.contacto')" class="btn -skull">Contactar</router-link>
    </div>
      </div>

      
  </section>


  </div>

</template>

<script lang="js">

  import bannerconectados from '@/components/parts/banner-conectados';
  import aldiabanner from '@/components/parts/al-dia-banner';

  import aldia from '@/components/view-parts/home/al-dia';

  import destacados from '@/components/parts/destacados';

  import filtro from '@/components/parts/filtro'

  import Slick from 'vue-slick';

  import { mapGetters } from 'vuex';

  export default {
    name: 'internacional',
    data() {
      return {
        showproyectoformativo: false,
        showFiltro: false,
        filter: '',
        page: 1,
        slickOptions: {
          slidesToShow: 1,
          dots: false,
          arrows: true,
          adaptiveHeight: false,
          autoplay: true,
          autoplaySpeed: 3000,
          variableWidth: false
        },
      }
    },
    computed: {
      ...mapGetters({
        recursos: 'getRecursosInternacional'
      }),
      elements() {

        let elements = new Array();

        if (!!this.filter) {

          elements = this.recursos;
          //AREAS
          if (!!this.filter.area) {
            elements = elements.filter(e => (e.area.some(a => a.slug == this.filter.area)));
          }

          if (!!this.filter.categoria) {
            elements = elements.filter(e => (e.categoria.some(a => a.slug == this.filter.categoria)));
          }

          if (!!this.filter.titulos) {
            elements = elements.filter(e => (e.titulos.some(a => a.slug == this.filter.titulos.slug)));
          }

          if (!!this.filter.tags) {
            elements = elements.filter(e => {
              let existe = false;

              if (!!e.tags) {
                e.tags.forEach(t => {
                  (this.filter.tags.some(tag => tag == t)) ? existe = true : null;
                })
              }

              return existe;

            });
          }

          if (!!this.filter.search) {

            let searchIn = ['titulo', 'entradilla'];

            elements = elements.filter(element => {

              let can = false;

              searchIn.forEach(where => {
                (element[where].toLowerCase().includes(this.filter.search.toLowerCase())) ? can = true : '';
              });

              return (can) ? element : '';
            });

          }

          if (!!this.filter.fecha) {
            let actual = new Date().getTime();
            const SEMANAVAL = 604800000;
            let limit;
            switch (this.filter.fecha) {
              case 'day':
                limit = (actual - SEMANAVAL);
                break;
              case 'month':
                limit = (actual - SEMANAVAL * 4);
                break;
              case 'ever':
                limit = 0;
                break;
            }

            elements = elements.filter(o => {
              let fecha = new Date(o.fecha.full).getTime();
              return (fecha >= limit);
            });


          }

        } else {
          elements = this.recursos;
        }

        return elements;
      },
      perpage() {
        return 9;
      },
      pages() {
        return Math.ceil(this.elements.length / this.perpage);
      },

    },
    methods: {
      prev() {
        if (this.page > 1) {
          this.page--;
        }
      },
      next() {
        if (this.page < this.pages) {
          this.page++;
        }
      },
      setPage(page) {
        this.page = page;
      },
      setArea(area) {
        $('html,body').animate({ scrollTop: $(".filtro").offset().top - 100 }, 500, 'swing');
        this.$refs.filtro.setArea(area)
      }
    },
    components: {
      'banner-conectados': bannerconectados,
      'al-dia-banner': aldiabanner,
      'al-dia': aldia,
      'destacados': destacados,
      'filtro': filtro,
      Slick
    },
    filters: {
      stringcategoria(value) {
        let cats = new Array();
        value.forEach(v => {
          cats.push(v.nombre);
        })
        let last = cats.pop();
        return cats.join(", ") + ' y ' + last;
      }
    }
  }
</script>

<style scoped lang="scss">
  .accesos-home {
    article {
      padding: 65px 20px;
      justify-content: flex-start;

      h2 {
        min-height: 72px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
/*
      &:nth-child(1) {
        background: url(/static/img/acceso-internacional-1.jpg) center/cover no-repeat;
      }

      &:nth-child(2) {
        background: url(/static/img/acceso-internacional-2.jpg) center/cover no-repeat;
      }

      &:nth-child(3) {
        background: url(/static/img/acceso-internacional-3.jpg) center/cover no-repeat;
      }*/
    }
  }


  @media screen and (max-width: 1400px) {
    .accesos article {
      padding: 50px 20px;
    }
  }

  @media screen and (max-width: 900px) {
    .accesos article {
      padding: 100px 20px;
    }
  }

  @media screen and (max-width: 500px) {
    .accesos article {
      padding: 100px 20px;
      width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/guia.vue